<template>
  <div>
    <el-form class="section top" style="flex-direction: row;line-height: 28px;min-width: 1600px;">
      <el-checkbox v-model="job.booking" :disabled="readonly" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
      <el-checkbox
        v-model="job.customs"
        :disabled="readonly"
        no="customs"
        @change="val=>{job.customsBroker=val?job.customsBroker:0;job.customsDeclarationType=val?job.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
      <el-checkbox
        v-model="job.comercialInspectation"
        :disabled="readonly"
        no="comercialInspectation"
      >{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="job.heating" :disabled="readonly" no="heating">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="job.itmService" :disabled="readonly" no="itmService">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
      <el-checkbox
        v-model="job.headwayTail"
        :disabled="readonly"
        no="headwayTail"
      >{{ $t('RailwayExport.isHeadwayTail') }}</el-checkbox>
      <el-button
        v-if="!previewConfig"
        v-permission="['button_insurance_toInsure']"
        :disabled="isEdit"
        no="toInsure"
        type="primary"
        style="margin-left: 20px"
        @click="toInsure"
      >{{ $t('SeaExport.Insure') }}</el-button>
      <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
      <el-radio-group v-model="job.lob" :disabled="readonly" no="lob" style="margin-left: 10px;" @change="lobChangeHandler">
        <el-radio no="RE" label="RE" style="margin-top: 6px;">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
        <el-radio no="RI" label="RI" style="margin-top: 6px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
      </el-radio-group>
    </el-form>
    <tab-railway-booking-UICustom-layout :element-blocks="elementBlocks">
      <template v-if="elementDict.cargoCode.visible" slot="cargoCode">
        <el-form-item>
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="cargoCode"
            :select-type="TYPE_NAMES.basic_data_CargoInformation"
            :disabled="readonly"
            filterable
            :clearable="true"
            :default-value="job.cargoCode"
            :allow-create="false"
            @parentCallBack="p=>{cargoCodeChange(p.value)}"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="job.cargoName"
            no="cargoName"
            :disabled="!(isEdit && job.cargoCode!='' && job.cargoCode!=null)"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.departureStation.visible" slot="departureStation">
        <line-label slot="label" :class="elementDict.departureStation.isRequire ? 'blue' : ''" :label="elementDict.departureStation.label" />
        <div style="display: flex;width: 100%;">
          <cargo-advance-select
            no="departureStation"
            :disabled="readonly"
            :select-type="TYPE_NAMES.basic_data_RailwayStation"
            filterable
            :default-value="job.departureStation"
            :placeholder="$t('SeaExport.RequiredItem')"
            @parentCallBack="departureStationChange"
          />
          <el-checkbox
            v-model="job.transfer"
            :disabled="readonly"
            no="transfer"
            style="width:80px; padding-left: 5px;"
          >{{ $t('SeaExport.Transit') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.transferStation.visible && job.transfer" slot="transferStation">
        <line-label slot="label" :class="elementDict.transferStation.isRequire ? 'blue' : ''" :label="elementDict.transferStation.label" />
        <cargo-advance-select
          no="transferStation"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_RailwayStation"
          filterable
          :default-value="job.transferStation"
          @parentCallBack="p=>{job.transferStation=p.value}"
        />
      </el-form-item>
      <template v-if="elementDict.diffPlacesCollaborate.visible" slot="diffPlacesCollaborate">
        <el-form-item>
          <el-checkbox
            slot="label"
            v-model="job.diffPlacesCollaborate"
            :disabled="readonly"
            no="diffPlacesCollaborate"
            class="blue"
          >{{ $t('RailwayExport.isDiffPlacesCollaborate') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.loadingPlaceCompany')">
          <cargo-company-select
            no="loadingPlaceCompany"
            :disabled="readonly"
            :method-params="{companyLob:'railwayExport',loadingPlaceCompany:true,active:true}"
            :check-credit="true"
            :job="job"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="job.loadingPlaceCompany||''"
            style="width: 100%"
            @change="p=>{job.loadingPlaceCompany=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.signBillPlaceCompany')">
          <cargo-company-select
            no="signBillPlaceCompany"
            :disabled="readonly"
            :method-params="{companyLob:'railwayExport',signBillPlaceCompany:true,active:true}"
            :check-credit="true"
            :job="job"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="job.signBillPlaceCompany||''"
            style="width: 100%"
            @change="p=>{job.signBillPlaceCompany=p.value}"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.fullShipment.visible" slot="fullShipment">
        <el-form-item>
          <el-checkbox
            slot="label"
            v-model="job.fullShipment"
            :disabled="readonly"
            no="fullShipment"
            class="blue"
          >{{ $t('RailwayExport.isFullShipment') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.dischargePortCompany')">
          <cargo-company-select
            no="dischargePortCompany"
            :disabled="readonly"
            :method-params="{companyLob:'railwayExport',dischargePortCompany:true,active:true}"
            :check-credit="true"
            :job="job"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="job.dischargePortCompany||''"
            style="width: 100%"
            @change="p=>{job.dischargePortCompany=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.destinationPortCompany')">
          <cargo-company-select
            no="destinationPortCompany"
            :disabled="readonly"
            :method-params="{companyLob:'railwayExport',destinationPortCompany:true,active:true}"
            :check-credit="true"
            :job="job"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="job.destinationPortCompany||''"
            style="width: 100%"
            @change="p=>{job.destinationPortCompany=p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.poNo.visible" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="poNo" />
        <cargo-project-select
          v-if="openProjectConfig"
          :disabled="readonly"
          no="22"
          :default-value="job.poNo"
          :customer-id="job.customerId"
          :is-linked="isProjectLinkedCustomer"
          @change="changeProject"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.visible" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :disabled="readonly"
          :office-id="Number(job.plannerOffice)"
          :enables="true"
          :department-id="Number(job.plannerDepartment)"
          @change="p=>{job.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.visible" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-advance-select
          no="plannerOffice"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.plannerOffice||''"
          @parentCallBack="p=>{job.plannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.projectName.visible && openProjectConfig" slot="projectName">
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="job.projectName" no="projectName" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.projectBatch.visible && openProjectConfig" slot="projectBatch">
        <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
        <el-input v-model="job.projectBatch" :disabled="readonly" no="projectBatch" />
      </el-form-item>
      <el-form-item v-if="elementDict.contactTelephone.visible" slot="contactTelephone">
        <line-label slot="label" :class="elementDict.contactTelephone.isRequire ? 'blue' : ''" :label="elementDict.contactTelephone.label" />
        <el-input
          v-model="job.contactTelephone"
          no="contactTelephone"
          :disabled="!electricBusinessBtnEnable || readonly"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.contactFax.visible" slot="contactFax">
        <line-label slot="label" :class="elementDict.contactFax.isRequire ? 'blue' : ''" :label="elementDict.contactFax.label" />
        <el-input
          v-model="job.contactFax"
          no="contactFax"
          :disabled="!electricBusinessBtnEnable || readonly"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.doorName.visible && job.landTransportation" slot="doorName">
        <line-label slot="label" :class="elementDict.doorName.isRequire ? 'blue' : ''" :label="elementDict.doorName.label" />
        <el-select
          v-model="truckingInfo.doorName"
          :disabled="readonly"
          no="doorName"
          value-key="name"
          clearable
          filterable
          :allow-create="true"
          @change="doorsChangeHandler"
        >
          <el-option
            v-for="(item,index) in doorList"
            :key="index"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.contactPerson.visible && job.landTransportation" slot="contactPerson">
        <line-label slot="label" :class="elementDict.contactPerson.isRequire ? 'blue' : ''" :label="elementDict.contactPerson.label" />
        <div style="display: flex">
          <el-input v-model="truckingInfo.doorMan" :disabled="readonly" no="doorMan" :placeholder="$t('Payment.contactPerson')" />
          <div :class="elementDict.contactPerson.isRequire ? 'blue' : ''" style="width: 65px;padding:0 10px;font-size: 12px;">{{ $t('SeaExport.Tel') }}</div>
          <el-input v-model="truckingInfo.doorManTel" :disabled="readonly" no="doorManTel" :placeholder="$t('SeaExport.Tel')" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.doorAddr.visible && job.landTransportation" slot="doorAddr">
        <line-label slot="label" :class="elementDict.doorAddr.isRequire ? 'blue' : ''" :label="elementDict.doorAddr.label" />
        <el-input
          v-model="truckingInfo.doorAddr"
          :disabled="readonly"
          no="doorAddr"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog(elementDict.doorAddr.label,truckingInfo.doorAddr,val=>{truckingInfo.doorAddr=val})"
        />
      </el-form-item>
      <!-- <el-form-item v-show="elementDict.bookingRefuseNote.visible && job.preverifyState===3" slot="bookingRefuseNote">
        <line-label slot="label" :class="elementDict.bookingRefuseNote.isRequire ? 'blue' : ''" :label="elementDict.bookingRefuseNote.label" />
        <el-input v-model="job.bookingRefuseNote" no="bookingRefuseNote" type="textarea" :rows="3" :disabled="true" />
      </el-form-item> -->
      <template v-if="isAddUserDefinedRoles">
        <el-form-item v-if="elementDict.userDefinedRoleId1.visible" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            no="userDefinedRoleId1"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            placeholder=" "
            :static-options="userPortRoleData.userDefinedRole1"
            @change="userDefinedRoleId1Handler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId2.visible" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            no="userDefinedRoleId2"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            placeholder=" "
            :static-options="userPortRoleData.userDefinedRole2"
            @change="userDefinedRoleId2Handler"
          />
        </el-form-item>
      </template>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.visible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-remoteBooking-re-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChange"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.visible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-remoteBooking-re-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChange"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.visible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="job.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.visible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="job.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.visible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="job.userDefinedRoleId5||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.visible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="job.userDefinedRoleId6||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.visible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="job.userDefinedRoleId7||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.visible" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="job.userDefinedField1"
          :disabled="readonly"
          no="userDefinedField1"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,val=>{job.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.visible" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="job.userDefinedField2"
          :disabled="readonly"
          no="userDefinedField2"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,val=>{job.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.visible" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="job.userDefinedField3"
          :disabled="readonly"
          no="userDefinedField3"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,val=>{job.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.visible" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="job.userDefinedField4"
          :disabled="readonly"
          no="userDefinedField4"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,val=>{job.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.visible" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="job.taxNature"
          :disabled="readonly"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form
        v-show="elementDict.shipper.visible"
        slot="shipper"
        label-width="50px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
          <cargo-company-select
            no="shipperId"
            :disabled="readonly"
            :method-params="{shipper:true,active:true}"
            :default-value="job.shipperId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateShipperList : null"
            style="display: inline-block;width:196px;"
            @change="shipperChange"
          />
          <el-button
            no="29"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'shipperLine'+i"
            v-model="job['shipperLine'+i]"
            :disabled="readonly"
            :no="'shipperLine'+i"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.consignee.visible"
        slot="consignee"
        label-width="65px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
          <cargo-company-select
            no="consigneeId"
            :disabled="readonly"
            :method-params="{consignee:true,active:true}"
            :default-value="job.consigneeId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateConsigneeList : null"
            style="display: inline-block;width:196px;"
            @change="consigneeChange"
          />
          <el-button
            no="53"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'consigneeLine'+i"
            v-model="job['consigneeLine'+i]"
            :disabled="readonly"
            :no="'consigneeLine'+i"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.notify.visible"
        slot="notify"
        label-width="50px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
          <cargo-company-select
            no="notifyId"
            :disabled="readonly"
            :method-params="{notify:true,active:true}"
            :default-value="job.notifyId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateNotifyList : null"
            style="display: inline-block;width:196px;"
            @change="notifyChange"
          />
          <el-button
            no="billAddressDialogVisible"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'notifyLine'+i"
            v-model="job['notifyLine'+i]"
            :disabled="readonly"
            :no="'notifyLine'+i"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true)"
          />
        </el-form-item>
      </el-form>
      <div v-if="elementDict.alsoNotify.visible" slot="alsoNotify">
        <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
        <br>
        <cargo-textarea
          v-model="job.alsoNotify"
          no="alsoNotify"
          type="textarea"
          :rows="12"
          :disabled="readonly"
          class="also-notify"
          @dblclick.native="showAdvanceTextDialog(elementDict.alsoNotify.label,job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
        />
      </div>
      <el-form-item v-if="elementDict.containerLoadType.visible" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="job.containerLoadType"
          no="containerLoadType"
          :disabled="readonly"
          @change="containerLoadType_Change()"
        >
          <el-option value="FCL" :label="$t('CargoMsg.Cargo_FCL')" />
          <el-option value="LCL" :label="$t('CargoMsg.Cargo_DirectConsol')" />
          <el-option value="BB" :label="$t('CargoMsg.Cargo_CoLoadConsol')" />
          <el-option value="BC" label="Buyer Console" />
          <el-option value="BULK" :label="$t('CargoMsg.Cargo_BulkCargo')" />
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
        slot="seaEq"
        label-width="0"
      >
        <booking-sea-eq-data-grid
          ref="bookingSeaEqDataGrid"
          :value="seaEqList"
          :container-load-type="job.containerLoadType"
          :is-edit="isEdit"
          :job="job"
          lob="RE"
          :hide-soc="true"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.quantityConsignActual.visible" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.quantityContract"
            :disabled="readonly"
            no="quantityContract"
            :precision="0"
            :min="0"
            @change="SEUtils.changeQWCRule(()=>{job.quantityActual=job.quantityContract},null)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="job.quantityActual"
            :disabled="readonly"
            no="quantityActual"
            :precision="0"
            :min="0"
            @change="SEUtils.changeQWCRule(null,()=>{job.quantityContract=job.quantityActual})"
          />
          <span>PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.weightConsignActual.visible" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.weightContract"
            :disabled="readonly"
            no="weightContract"
            :precision="3"
            :min="0"
            @change="SEUtils.changeQWCRule(()=>{job.weightActual=job.weightContract},null)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="job.weightActual"
            :disabled="readonly"
            no="weightActual"
            :precision="3"
            :min="0"
            @change="SEUtils.changeQWCRule(null,()=>{job.weightContract=job.weightActual})"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.cubageConsignActual.visible" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.cubageContract"
            :disabled="readonly"
            no="cubageContract"
            :precision="3"
            :min="0"
            @change="SEUtils.changeQWCRule(()=>{job.cubageActual=job.cubageContract},null)"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="job.cubageActual"
            :disabled="readonly"
            no="cubageActual"
            :precision="3"
            :min="0"
            @change="SEUtils.changeQWCRule(null,()=>{job.cubageContract=job.cubageActual})"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customerRefNo.visible" slot="customerRefNo">
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <cargo-input v-model="job.customerRefNo" :disabled="readonly" no="customerRefNo" :trim="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.jobNo.visible" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input v-model="job.jobNo" no="jobNo" :disabled="true" class="job-no-color" />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseNo.visible" slot="warehouseNo">
        <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
        <el-input v-model="job.warehouseNo" no="warehouseNo" :disabled="readonly" />
      </el-form-item>
      <el-form-item v-if="elementDict.quotationNo.visible" slot="quotationNo">
        <line-label slot="label" :class="elementDict.quotationNo.isRequire ? 'blue' : ''" :label="elementDict.quotationNo.label" />
        <el-input no="quotationNo" :value="job.quotationNo" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerId.visible" slot="customerId">
        <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
        <cargo-sales-company-select
          v-if="accountObjectControlMode === 2"
          no="customerId"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :method-params="{customer:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.customerId||''"
          :placeholder="$t('SeaExport.RequiredItem')"
          style="width: 100%;"
          @parentCallBack="txtCustomerId_changeHandler"
        />
        <cargo-company-select
          v-else
          no="customerId"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :method-params="{customer:true, active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.customerId||''"
          :static-options="customerCmpList"
          :placeholder="$t('SeaExport.RequiredItem')"
          style="width: 100%;"
          @change="txtCustomerId_changeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerContact.visible" slot="customerContact">
        <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
        <el-select
          v-model="job.customerContact"
          no="customerContact"
          :disabled="!electricBusinessBtnEnable || readonly"
          filterable
          :allow-create="true"
          placeholder=""
          @change="tfLinkman_closeHandler"
        >
          <el-option
            v-for="(item,index) in contactList"
            :key="index"
            :label="item.contactPerson"
            :value="item.contactPerson"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.sales.visible" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <cargo-user-select
          no="sales"
          :disabled="!(!job.trustFromJob&&electricBusinessBtnEnable&&(!validateCustomerSales||(isSpecifiedSalesBusiness&&validateCustomerSales))) || readonly"
          :method-params="{officeId:!isSpecifiedSalesBusiness&&salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
          :default-value="job.sales||''"
          :static-options="salesList"
          :placeholder="$t('SeaExport.RequiredItem')"
          @change="txtSales_changeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.visible" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="salesOffice"
          :disabled="!(job.sales>0&&job.salesDepartment>0) || readonly"
          :sales-id="job.sales"
          :office-id="job.salesOffice"
          :department-id="job.salesDepartment"
          :show-office-prefix="false"
          placeholder=" "
          @change="p=>{job.salesDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtSalesOffice.visible" slot="txtSalesOffice">
        <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
        <el-input v-model="txtSalesOffice" no="txtSalesOffice" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.visible" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :disabled="readonly"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="job.cargoSalesId||''"
          :static-options="cargoSalesList"
          placeholder=" "
          @change="cargoSalesChargeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.op.visible" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          no="op"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOfficeId}"
          :default-value="job.op||''"
          placeholder=" "
          :static-options="userPortRoleData.op"
          @change="txtOPChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.visible" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="opDepartment"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :office-id="job.opOffice"
          :enables="true"
          :department-id="job.opDepartment"
          placeholder=" "
          @change="p=>{job.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.visible" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-advance-select
          no="opOffice"
          :disabled="isEntrustOrder() || readonly"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.opOffice||''"
          placeholder=" "
          @parentCallBack="p=>{job.opOffice=p.value;opOfficeChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.visible" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          no="dc"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'doc',officeId:$store.getters.currentOfficeId}"
          :default-value="job.dc||''"
          :static-options="userPortRoleData.doc || dcList"
          placeholder=" "
          @change="dcChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.visible" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          no="csr"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'csr',officeId:job.opOffice}"
          :default-value="job.csr||''"
          :static-options="userPortRoleData.csr || csrList"
          placeholder=" "
          @change="csrChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.visible" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :disabled="readonly"
          :method-params="{category:'role',shape:'railwayLine',officeId:$store.getters.currentOfficeId}"
          :default-value="job.planner||''"
          placeholder=" "
          :static-options="userPortRoleData.railwayLine"
          @change="txtPlannerChangeHandler"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.overseaOp.visible" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          :disabled="readonly"
          :default-value="job.overseaOp||''"
          :method-params="{category:'role',shape:'overseaOp'}"
          :static-options="isHc ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
          :merge-load="true"
          @change="p=>{
            job.overseaOp = p.value
            OverseaCustomerUtils.overseaOpChangeHandler(view, p)
          }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.visible" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          no="siteOP"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
          :default-value="job.siteOP||''"
          placeholder=" "
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.visible" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :disabled="readonly"
          :office-id="Number(job.csrOffice)"
          :enables="true"
          :department-id="Number(job.csrDepartment)"
          @change="p=>{job.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.visible" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-advance-select
          no="csrOffice"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.csrOffice||''"
          @parentCallBack="p=>{job.csrOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.visible" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :disabled="readonly"
          :office-id="Number(job.dcOffice)"
          :enables="true"
          :department-id="Number(job.dcDepartment)"
          @change="p=>{job.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.visible" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-advance-select
          no="dcOffice"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.dcOffice||''"
          @parentCallBack="p=>{job.dcOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportType.visible" slot="transportType">
        <line-label slot="label" :class="elementDict.transportType.isRequire ? 'blue' : ''" :label="elementDict.transportType.label" />
        <cargo-advance-select
          no="transportType"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_TransportationType"
          filterable
          :default-value="job.transportType"
          :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
          :tag-value="'code'"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{job.transportType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.fullHalf.visible" slot="fullHalf">
        <line-label slot="label" :class="elementDict.fullHalf.isRequire ? 'blue' : ''" :label="elementDict.fullHalf.label" />
        <cargo-advance-select
          no="fullHalf"
          :disabled="readonly"
          :select-type="TYPE_NAMES.local_cache_FullHalf"
          filterable
          :default-value="job.fullHalf"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{job.fullHalf=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportLine.visible" slot="transportLine">
        <line-label slot="label" :class="elementDict.transportLine.isRequire ? 'blue' : ''" :label="elementDict.transportLine.label" />
        <cargo-advance-select
          no="transportLine"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_RailwayLine"
          filterable
          :default-value="job.transportLine"
          :placeholder="$t('SeaExport.RequiredItem')"
          tag-name="name"
          @parentCallBack="p=>{job.transportLine=p.value;onTransportLineChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.visible" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <el-date-picker v-model="job.etd" :disabled="readonly" no="etd" type="date" value-format="yyyy-MM-dd" clearable :placeholder="$t('SeaExport.RequiredItem')" />
      </el-form-item>
      <el-form-item v-if="elementDict.eta.visible && job.lob==='RE'" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <el-date-picker v-model="job.eta" :disabled="readonly" no="eta" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <el-form-item v-if="elementDict.eta.visible && job.lob==='RI'" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <el-date-picker v-model="job.eta" :disabled="readonly" no="eta" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <div v-if="elementDict.customsDate && elementDict.customsDate.visible && $store.getters.enableFrontEndPlugin" slot="customsDate">
        <micro-app
          name="child-operation-date-re"
          :url="$store.getters.frontEndPluginUrl+'/operationDateItem'"
          router-mode="pure"
          destroy
          @datachange="operationDateDataChange"
        />
      </div>
      <el-form-item v-if="elementDict.customsDate && elementDict.customsDate.visible && job.lob==='RE' && !$store.getters.enableFrontEndPlugin" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate && elementDict.customsDate.visible && job.lob==='RI' && !$store.getters.enableFrontEndPlugin" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <el-form-item v-if="elementDict.transitStation.visible" slot="transitStation">
        <line-label slot="label" :class="elementDict.transitStation.isRequire ? 'blue' : ''" :label="elementDict.transitStation.label" />
        <cargo-advance-select
          no="transitStation"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_RailwayStation"
          filterable
          :default-value="job.transitStation"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{job.transitStation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationStation.visible" slot="destinationStation">
        <line-label slot="label" :class="elementDict.destinationStation.isRequire ? 'blue' : ''" :label="elementDict.destinationStation.label" />
        <cargo-advance-select
          no="destinationStation"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_RailwayStation"
          filterable
          :default-value="job.destinationStation"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="destinationStationChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationCountry.visible" slot="destinationCountry">
        <line-label slot="label" :class="elementDict.destinationCountry.isRequire ? 'blue' : ''" :label="elementDict.destinationCountry.label" />
        <cargo-advance-select
          no="destinationCountry"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Country"
          filterable
          :default-value="job.destinationCountry"
          @parentCallBack="p=>{job.destinationCountry=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.visible" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <cargo-advance-select
          no="cargoSource"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.local_cache_CargoSource"
          :default-value="job.cargoSource"
          :clearable="false"
          @parentCallBack="p=>{job.cargoSource=p.value;cargoSource_Change();txtCargoSourceChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.customJobType.visible" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          ref="customJobType"
          no="customJobType"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_CutomJobType"
          filterable
          :static-options="getCustomJobType"
          :default-value="job.customJobType"
          :placeholder="$t('Message.PleaseSelect')"
          @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.portAgent.visible" slot="portAgent">
        <line-label slot="label" :class="elementDict.portAgent.isRequire ? 'blue' : ''" :label="elementDict.portAgent.label" />
        <cargo-advance-select
          no="portAgent"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{companyLob:'railwayExport',portAgent:true,active:true}"
          filterable
          :default-value="job.portAgent||''"
          @parentCallBack="p=>{job.portAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.forwardingAgent.visible" slot="forwardingAgent">
        <line-label slot="label" :class="elementDict.forwardingAgent.isRequire ? 'blue' : ''" :label="elementDict.forwardingAgent.label" />
        <cargo-advance-select
          no="forwardingAgent"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{companyLob:'railwayExport',forwardingAgent:true,active:true}"
          filterable
          :default-value="job.forwardingAgent||''"
          @parentCallBack="p=>{job.forwardingAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.destinationAgent.visible" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <cargo-company-select
          ref="destinationAgent"
          no="destinationAgent"
          :disabled="readonly"
          :method-params="{overseaAgent:true,active:true,companyLob:'railwayExport'}"
          :check-credit="true"
          :job="job"
          :default-value="job.destinationAgent||''"
          filterable
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          style="width:300px;"
          @change="txtDestinationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.designationAgent.visible && job.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <cargo-company-select
          no="designationAgent"
          :disabled="readonly"
          :method-params="{designationAgent:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.designationAgent||''"
          tag-name="englishName"
          placeholder=" "
          style="width:300px;"
          @change="txtDesignationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentMethod.visible" slot="paymentMethod">
        <line-label slot="label" :class="elementDict.paymentMethod.isRequire ? 'blue' : ''" :label="elementDict.paymentMethod.label" />
        <cargo-advance-select
          no="paymentMethod"
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_PaymentMethod"
          :method-params="{companyLob:'railwayExport',paymentMethod:true,active:true}"
          filterable
          :default-value="job.paymentMethod"
          :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
          :tag-value="'code'"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{job.paymentMethod=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.vessel.visible" slot="vessel">
        <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
        <el-input v-model="job.vessel" :disabled="readonly" no="vessel" />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.visible" slot="voyageFlight">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <el-input v-model="job.voyageFlight" :disabled="readonly" no="voyageFlight" />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.visible" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <cargo-advance-select
          no="cargoType"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_CargoType"
          :headers="[$t('Partners.chineseName')]"
          :fields="['chineseName']"
          :filter-field-names="['chineseName']"
          :method-params="{sea:true}"
          filterable
          :clearable="false"
          :default-value="job.cargoType"
          @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.visible" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="packing"
          :disabled="readonly"
          :default-value="job.packing"
          placeholder=" "
          style="width: 260px;"
          @change="p=>{job.packing=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.visible" slot="cargoChineseName">
        <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
        <cargo-textarea
          v-model="job.cargoChineseName"
          no="cargoChineseName"
          type="textarea"
          :rows="3"
          :disabled="!isEdit"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val}, true, {autoUppercase:true})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.visible" slot="cargoEnglishName">
        <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
        <cargo-textarea
          v-model="job.cargoEnglishName"
          no="cargoEnglishName"
          type="textarea"
          :rows="3"
          :disabled="!isEdit"
          :auto-uppercase="isUppercaseByConfig"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val}, isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.hsCode.visible" slot="hsCode">
        <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
        <el-input
          v-model="job.hsCode"
          :disabled="readonly"
          no="hsCode"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{job.hsCode=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mark.visible" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <cargo-textarea
          v-model="job.mark"
          no="mark"
          type="textarea"
          :rows="3"
          :disabled="!isEdit"
          :auto-uppercase="isUppercaseByConfig"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsBroker.visible" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          no="customsBroker"
          :disabled="!job.customs || readonly"
          :select-type="TYPE_NAMES.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="job.customsBroker||''"
          :placeholder="$t('SeaExport.PleaseTickCustomsDeclarationOption')"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          @parentCallBack="p=>{customsBrokerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.visible" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="!job.customs || readonly"
          :select-type="TYPE_NAMES.basic_data_CustomsDeclarationType"
          filterable
          :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{job.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carryingCmp.visible && !isSalesForSzfs" slot="carryingCmp">
        <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
        <cargo-company-select
          no="landTransportation"
          :disabled="!job.landTransportation || readonly"
          :method-params="{truckCmp:true,active:true}"
          :default-value="job.carryingCmp||''"
          :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
          style="width: 100%;"
          @change="carryingCmpChangeHandler"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.satisfiedRequests.visible" slot="satisfiedRequests">
        <special-requests-grid
          ref="selectedSpecialRequest"
          v-model="job.satisfiedRequests"
          no="satisfiedRequests"
          :is-edit="isEdit"
          :customer-id="job.customerId"
          :lob="job.lob"
          :job="job"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.visible" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="job.remarks"
          :disabled="readonly"
          no="remarks"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.slaveVisible" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="job.rateType"
          :disabled="readonly"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
    </tab-railway-booking-UICustom-layout>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :own-permission="hasChooseOwnTransceiverPermission"
      :customer-cmp-list="customerCmpList"
      :use-empty-customer-cmp-list="true"
      @callback="codeSearchCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabRailwayBookingUICustomLayout from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabRailwayBookingUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabReBooking from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabReBooking.vue'
import StrUtils from '@/utils/StrUtils'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabRailwayBookingUICustom',
  components: { cargoTextarea, tabRailwayBookingUICustomLayout, cargoProjectSelect },
  extends: tabReBooking,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      operationDateData: { // 子应用操作日期
        filedLable: 'SeaExport.OperationDate',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'operationDate',
        fieldData: this.job ? this.job.customsDate : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: ''
      },
      userDefinedRoleData: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  computed: {
    lob() {
      return this.job.lob
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    lob() {
      this.loadPageConfig()
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    async changeProject(p) {
      this.job.poNo = p.value
      this.job.projectName = p.projectName
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.job.poNo).then(res => {
          return res.data
        })
        if (company && this.job.customerId !== company.cmpIdx && company.active) {
          await this.txtCustomerId_changeHandler(company)
        }
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageType = this.lob === 'RE' ? UICustomConstants.REMOTE_RE_BOOKING_BASIC : UICustomConstants.REMOTE_RI_BOOKING_BASIC
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.job
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.visible && field.isRequire) {
          if (key === 'agentRefNo') {
            if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
              continue
            }
          }
          if (key === 'projectName' || key === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'shipperLine1') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabReBooking')
            }
            continue
          }
          if (key === 'consigneeLine1') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabReBooking')
            }
            continue
          }
          if (key === 'notifyLine1') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabReBooking')
            }
            continue
          }
          if (key.startsWith('shipperLine') || key.startsWith('consigneeLine') || key.startsWith('notifyLine')) {
            continue
          }
          if (key === 'transfer') {
            if (form.transfer && StrUtils.isEmpty(form.transferStation)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabReBooking')
            }
          } else if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabReBooking')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabReBooking')
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.visible && this.elementDict.seaEq.isRequire) {
        if (form.containerLoadType === 'FCL' || form.containerLoadType === 'BB') {
          if (!this.seaEqList || this.seaEqList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabReBooking')
          }
          for (const seaEq of this.seaEqList) {
            if (!seaEq.eqQuantity) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabReBooking')
            }
          }
        }
      }
      if (this.elementDict.carryingCmp && this.elementDict.carryingCmp.visible && this.elementDict.carryingCmp.isRequire) {
        if (!this.form.carryingCmp && !this.isSalesForSzfs) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.carryingCmp.label]), 'tabReBooking')
        }
      }
      if (form.landTransportation) {
        if (this.elementDict.doorName.visible && this.elementDict.doorName.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorName)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.doorName.label]), 'tabReBooking')
          }
        }
        if (this.elementDict.contactPerson.visible && this.elementDict.contactPerson.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorMan)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.contactPerson.label]), 'tabReBooking')
          }
          if (StrUtils.isEmpty(this.truckingInfo.doorManTel)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Tel')]), 'tabReBooking')
          }
        }
        if (this.elementDict.doorAddr.visible && this.elementDict.doorAddr.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorAddr)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.doorAddr.label]), 'tabReBooking')
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setOperationDateData() {
      this.operationDateData.fieldData = this.job.customsDate
      this.operationDateData.disabled = this.readonly
      console.log('主应用发送OperationDate:', this.operationDateData)
      microApp.forceSetData('child-operation-date-re', this.operationDateData)
    },
    operationDateDataChange(e) {
      console.log('主应用获取OperationDate:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateData()
        } else {
          this.job.customsDate = e.detail.data.fieldData
        }
      }
    },
    setUserDefinedRoleData() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleData }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-remoteBooking-re-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleData }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-remoteBooking-re-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChange(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleData()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /deep/ {
    .job-no-color.el-input {
      .el-input__inner {
        background: #ffffcc !important;
      }
    }
    .el-form-item__content {
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      .el-date-editor {
        width: 100%;
      }
    }
    .blue {
      .el-checkbox__label {
        color: #1f75d5;
      }
    }
  }
  .poNoClass {
    /deep/ .el-input.is-disabled .el-input__inner {
      color: red !important;
    }
  }
  /deep/ .also-notify {
    width: 310px;
    .el-textarea__inner {
      height: 230px;
    }
  }
</style>
